import {Component, Input, ViewEncapsulation} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

export interface IDialogOptions {
  size?: 'sm' | 'lg' | 'xl' | string,

  title?: string,
  html?: string,
  content?: string,
  subContent?: string,

  btnCloseDisable?: boolean,
  btnCloseName?: string,
  btnCloseClass?: string,

  btnConfirmName?: string,
  btnConfirmClass?: string,

  backdropClass?: string,
  modalDialogClass?: string,
  windowClass?: string,
}

@Component({
  standalone: false,
  selector: 'app-c-confirm-dialog',
  template: `
      <ng-container *transloco="let t">
        <div class="modal-header py-2 bg-light">
          <h5 class="modal-title">
            {{ t(data.title ? data.title : 'common.notification') }}
          </h5>
          @if (!data.btnCloseDisable) {
            <button type="button"
            class="btn-close" (click)="onNotConfirm()"></button>
          }
        </div>
        <div class="modal-body">
          @if (data.html) {
            <div [innerHTML]="data.html"></div>
          } @else {
            {{ t(data.content ? data.content : 'common.messages.confirmDelete') }}
            @if (data.subContent) {
              <div [innerHTML]="data.subContent"></div>
            }
          }
        </div>
        <div class="modal-footer py-1">
          @if (data.btnCloseName) {
            <button (click)="onNotConfirm()" class="btn btn-sm {{data.btnCloseClass}}">
              <i class="ph ph-x me-2"></i>
              {{ data.btnCloseName | transloco }}
            </button>
          }
      
          <button (click)="onConfirm()" class="btn btn-sm {{data.btnConfirmClass ? data.btnConfirmClass : 'btn-danger'}}">
            <i class="ph ph-check me-2"></i>
            {{ t(data.btnConfirmName ? data.btnConfirmName : 'common.delete') }}
          </button>
        </div>
      </ng-container>
      `,
  encapsulation: ViewEncapsulation.None
})
export class ConfirmDialogComponent {
  @Input() data: IDialogOptions = {};

  constructor(
    public activeModal: NgbActiveModal
  ) {

  }

  onNotConfirm() {
    this.activeModal.close({confirmDelete: false});
  }

  onConfirm() {
    this.activeModal.close({confirmDelete: true});
  }
}
